// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"39cc02d2","488":"40105df9","977":"21ff4432"}[chunkId] + ".chunk.js";
};